module.exports = __webpack_public_path__ + "img/bay.b60cc651.svg";